<template>
    <div class="update-card-wrapper">
        <transition
            name="fade"
            mode="out-in"
        >
            <template
                v-if="! cardEditing"
            >
                <card-box
                    key="cardBox"
                    :upgrade-option="true"
                    :title="title"
                    :update-text="updateText"
                    @switch-to-upgrade="switchToUpdateCard"
                />
            </template>
            <template v-else>
                <update-billing-handler
                    v-slot:default="{
                        updatePaymentMethod,
                        cardProcessing,
                    }"
                    key="cardEditing"
                    :without-subscription="withoutSubscription"
                    @update-finished="switchToUpdateCard"
                    @update-without-subscription-finished="$emit('update-finished')"
                >
                    <card-form
                        :update="true"
                        :external-form-processing="cardProcessing"
                        @stripe-success="paymentMethod => updatePaymentMethod(paymentMethod)"
                        @cancel="switchToUpdateCard"
                    />
                </update-billing-handler>
            </template>
        </transition>
    </div>
</template>

<script>
import UpdateBillingHandler from './UpdateBillingHandler';
import CardForm from './CardForm';
import CardBox from '@/components/Dashboard/Settings/Billing/CardBox';

export default {
    components: {
        CardForm,
        CardBox,
        UpdateBillingHandler,
    },

    props: {
        title: {
            type: String,
            default: 'Credit Card',
        },
        updateText: {
            type: String,
            default: 'Update Credit Card',
        },
        withoutSubscription: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        cardEditing: false,
    }),

    methods: {
        /**
         * Handle card forms switch
         *
         */
        switchToUpdateCard() {
            this.cardEditing = ! this.cardEditing;
            this.$emit('card-form-switch');
        },

    },
};
</script>
